export class TrifectaBaseError extends Error {
  constructor(
    message: string,
    public readonly cause: Error | null = null
  ) {
    super(message);
  }
}

export class TrifectaInsufficientFundsError extends TrifectaBaseError {
  constructor(cause: Error | null = null) {
    super(TrifectaApiErrors.InsufficientFunds, cause);
  }
}

export class TrifectaInvalidSessionError extends TrifectaBaseError {
  constructor(cause: Error | null = null) {
    super(TrifectaApiErrors.InvalidSession, cause);
  }
}

export class TrifectaUnknownError extends TrifectaBaseError {
  constructor(cause: Error | null = null) {
    super(TrifectaApiErrors.UnknownError, cause);
  }
}

export class TrifectaConnectionError extends TrifectaBaseError {
  constructor(cause: Error | null = null) {
    super(TrifectaApiErrors.ConnectionError, cause);
  }
}

export const enum TrifectaApiErrors {
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidSession = 'INVALID_SESSION',
  UnknownError = 'UNKNOWN_ERROR',
  ConnectionError = 'CONNECTION_ERROR',
}
